import Component from '@cell/cell-core/component/component';
import './seals.scss';

class Seals extends Component {
  constructor() {
    super();

    this.elements = {
      list: this.querySelector('.Seals__List'),
      items: this.querySelectorAll('.Seals__Item'),
      bullets: this.querySelectorAll('.Seals__Bullet'),
    };

    this.viewIndex = 0;
    this.autoScrollDirection = 'next';
    this.autoScrollDelay = 4000;

    this.handleScroll = this.handleScroll.bind(this);
    this.disableAutoScroll = this.disableAutoScroll.bind(this);
  }

  componentDidMount() {
    this.elements.list.on('scroll', this.handleScroll);
    this.elements.list.on('touchstart', this.disableAutoScroll);

    this.autoScrollInterval = setInterval(() => {
      this.autoScroll();
    }, this.autoScrollDelay);
  }

  handleScroll() {
    // Determine the view index.

    const scrollLeft = this.elements.list.scrollLeft;

    this.viewIndex = Array.from(this.elements.items).findIndex((item) => {
      return item.offsetLeft >= scrollLeft;
    });

    // Update the bullets.

    this.elements.bullets.forEach((bullet, index) => {
      if (index === this.viewIndex) {
        bullet.classList.add('Seals__Bullet--Active');
      } else {
        bullet.classList.remove('Seals__Bullet--Active');
      }
    });
  }

  autoScroll() {
    // Determine direction.
    if (this.autoScrollDirection === 'next' && this.viewIndex === this.elements.items.length - 1) {
      this.autoScrollDirection = 'prev';
    } else if (this.autoScrollDirection === 'prev' && this.viewIndex === 0) {
      this.autoScrollDirection = 'next';
    }

    // Scroll in the direction.
    if (this.autoScrollDirection === 'next') {
      this.next();
    } else {
      this.prev();
    }
  }

  next() {
    this.viewIndex += 1;

    const scrollOffsetLeft = this.elements.items[this.viewIndex].offsetLeft;

    this.elements.list.scroll({
      left: scrollOffsetLeft,
      behavior: 'smooth',
    });
  }

  prev() {
    this.viewIndex -= 1;

    const scrollOffsetLeft = this.elements.items[this.viewIndex].offsetLeft;

    this.elements.list.scroll({
      left: scrollOffsetLeft,
      behavior: 'smooth',
    });
  }

  disableAutoScroll() {
    clearInterval(this.autoScrollInterval);
  }
}

customElements.define('c-seals', Seals);
